import script from "./InputFelt.vue?vue&type=script&setup=true&lang=js"
export * from "./InputFelt.vue?vue&type=script&setup=true&lang=js"

import "./InputFelt.vue?vue&type=style&index=0&id=635f2b5c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-635f2b5c"]])

export default __exports__